import DatePicker from './Date';
import TimePicker from './Time';

export default class KPicker {
  static Date = DatePicker;

  static Time = TimePicker;
}
